import React, { Component } from 'react';

class Newsletter extends Component
{
    render()
    {
        return (
            <div>
                Newsletter
            </div>
        )
    }
}

export default Newsletter;


// WEBPACK FOOTER //
// ./src/components/Newsletter/Newsletter.js